import type { RegisteredPost } from "@/lib/post";

export default {
  __type: "post",
  published: true,
  author: "Zach Garrett",
  title: "Value Functions",
  tags: ["formal methods", "lattice theory", "learning"],
  summary: "Bellman operators for value-based port selection",
  posts: {},
} satisfies RegisteredPost;

